<header class="app-header">

  <div class="logo">
    <img src="assets/Sky_Logo.png" alt="Sky Logo" />
  </div>

  <nav class="menu">
    <a routerLink="/home"
       routerLinkActive="active-menu"
       [routerLinkActiveOptions]="{ exact: true }">
      Home
    </a>

    <a routerLink="/search"
       routerLinkActive="active-menu">
      Search Files
    </a>
  </nav>

  <div class="user-section">
    <div class="user-icon">
      {{ userInitials }}
    </div>
    <span class="username">{{ displayName }}</span>
    <a (click)="logout()" class="logout-link">Sign Out</a>
  </div>

</header>
